import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import type { PaginatedList } from '@shared/types/common';
import type { ExerciseVideo } from '@shared/types/exercises';
import { CreateExerciseVideoDto } from '@src/api/exercises.ts';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';

export const useCreateExerciseMutation = () => {
  return useMutation({
    mutationFn: async (params: CreateExerciseVideoDto) => await API.exercises.create(params),
    onSuccess: async (response, variables) => {
      if (!variables.isTempExercise) {
        queryClient.setQueriesData(
          { queryKey: ['exercises'] },
          (oldData: InfiniteData<PaginatedList<ExerciseVideo>>) => {
            if (!oldData) return oldData;
            return {
              ...oldData,
              pages: oldData.pages.map((page, i) => {
                if (i === oldData.pages.length - 1) {
                  return {
                    ...page,
                    results: [...page.results, { ...response.data }],
                  };
                }
                return page;
              }),
            };
          }
        );

        await queryClient.invalidateQueries({ queryKey: ['exercises'] });
      }
    },
  });
};
